import "./styles.css";
import { useState, useEffect } from "react";
import sub1 from "../../../img/subscriptions/1.jpg";
// import sub2 from "../../../img/subscriptions/2.jpg";
// import sub3 from "../../../img/subscriptions/3.jpg";
import sub4 from "../../../img/subscriptions/4.jpg";
import sub5 from "../../../img/subscriptions/5.jpg";
import sub7 from "../../../img/subscriptions/7.jpg";
import sub9 from "../../../img/subscriptions/9.jpg";
import sub10 from "../../../img/subscriptions/10.jpg";
import sub13 from "../../../img/subscriptions/13.jpg";
import sub16 from "../../../img/subscriptions/16.jpg";
import sub17 from "../../../img/subscriptions/17.jpg";
import sub19 from "../../../img/subscriptions/19.jpg";
import sub21 from "../../../img/subscriptions/21.jpg";
import sub25 from "../../../img/subscriptions/25.jpg";
import logo from "../../../img/logo_2.png";
import React from "react";
import ButtonHead from "../../buttonHead";

const SubscriptionsHome = () => {
  const subscriptions = [
    // {
    //   id: 1,
    //   name: "Game Pass Ultimate на 1 месяц",
    //   price: "990₽",
    //   // img: sub1,
    // },
    {
      id: 2,
      name: "Game Pass Ultimate на 2 месяца",
      price: "1290₽",
      // img: sub1,
    },
    {
      id: 3,
      name: "Game Pass Ultimate на 3 месяца",
      price: "2190₽",
      // img: sub1,
    },
    {
      id: 4,
      name: "Game Pass Ultimate на 4 месяца",
      price: "2690₽",
      // img: sub4,
    },
    {
      id: 5,
      name: "Game Pass Ultimate на 5 месяцев",
      price: "3490₽",
    },
    // {
    //   id: 6,
    //   name: "Game Pass Ultimate на 6 месяцев",
    //   price: "3690₽",
    // },
    {
      id: 7,
      name: "Game Pass Ultimate на 7 месяцев",
      price: "4690₽",
      // img: sub7,
    },
    {
      id: 8,
      name: "Game Pass Ultimate на 8 месяцев",
      price: "5390₽",
      // img: sub7,
    },
    {
      id: 9,
      name: "Game Pass Ultimate на 9 месяцев",
      price: "5690₽",
      // img: sub7,
    },
    // {
    //   id: 10,
    //   name: "Game Pass Ultimate на 10 месяцев + 1 бонусный",
    //   price: "6090₽",
    //   // img: sub10,
    // },

    {
      id: 13,
      name: "Game Pass Ultimate на 13 месяцев",
      price: "7990₽",
      // img: sub13,
    },

    {
      id: 16,
      name: "Game Pass Ultimate на 16 месяцев",
      price: "8990₽",
      // img: sub16,
    },

    {
      id: 19,
      name: "Game Pass Ultimate на 19 месяцев",
      price: "11490₽",
      // img: sub19,
    },
  ];

  const subscriptionsOld = [
    {
      id: 1,
      name: "Game Pass Ultimate на 1 месяц",
      price: "1290₽",
      // img: sub1,
    },
    {
      id: 2,
      name: "Game Pass Ultimate на 2 месяца",
      price: "2290₽",
      // img: sub1,
    },
    {
      id: 3,
      name: "Game Pass Ultimate на 3 месяца ",
      price: "2690₽",
      // img: sub1,
    },
    {
      id: 4,
      name: "Game Pass Ultimate на 4 месяца",
      price: "3690₽",
      // img: sub4,
    },
    {
      id: 5,
      name: "Game Pass Ultimate на 5 месяцев",
      price: "3990₽",
    },
    {
      id: 6,
      name: "Game Pass Ultimate на 6 месяцев",
      price: "4990₽",
    },
    {
      id: 7,
      name: "Game Pass Ultimate на 7 месяцев",
      price: "5390₽",
      // img: sub7,
    },
    {
      id: 8,
      name: "Game Pass Ultimate на 8 месяцев",
      price: "6390₽",
      // img: sub7,
    },
    {
      id: 9,
      name: "Game Pass Ultimate на 9 месяцев",
      price: "6790₽",
      // img: sub7,
    },
    {
      id: 10,
      name: "Game Pass Ultimate на 10 месяцев",
      price: "7790₽",
      // img: sub10,
    },

    {
      id: 11,
      name: "Game Pass Ultimate на 11 месяцев",
      price: "8190₽",
    },
    {
      id: 12,
      name: "Game Pass Ultimate на 12 месяцев",
      price: "9190₽",
    },

    {
      id: 13,
      name: "Game Pass Ultimate на 13 месяцев",
      price: "9590₽",
      // img: sub13,
    },

    {
      id: 14,
      name: "Game Pass Ultimate на 14 месяцев",
      price: "10590₽",
    },

    {
      id: 15,
      name: "Game Pass Ultimate на 15 месяцев",
      price: "10890₽",
    },

    {
      id: 16,
      name: "Game Pass Ultimate на 16 месяцев",
      price: "11890₽",
      // img: sub16,
    },

    {
      id: 17,
      name: "Game Pass Ultimate на 17 месяцев",
      price: "12290₽",
      // img: sub16,
    },
    {
      id: 18,
      name: "Game Pass Ultimate на 18 месяцев",
      price: "13290₽",
    },

    {
      id: 19,
      name: "Game Pass Ultimate на 19 месяцев",
      price: "13690₽",
      // img: sub19,
    },
  ];
  useEffect(() => {}, []);

  return (
    <>
      <ButtonHead />
      <div className="gpoup-information__text" style={{ margin: "20px" }}>
        Подписки Game Pass Ultimate
      </div>
      <div>📌Любой аккаунт: </div>
      <div className="subscriptions">
        {subscriptionsOld.map((item) => (
          <div className="subscriptions__item">
            {/* <img
              className="subscriptions__item-img"
              src={item.img}
              alt="Подписка"
            /> */}
            <span className="subscriptions__item-name">{item.name}</span>
            <span> - </span>
            <span className="subscriptions__item-price">{item.price}</span>
          </div>
        ))}
        <span className="subscriptions__item-name">
          Game Pass Essential 12 месяцев - 3790р (новый аккаунт)
        </span>
        <span className="subscriptions__item-name">
          Game Pass Essential 12 месяцев - 4790р (любой аккаунт)
        </span>
        <span className="subscriptions__item-name">
          Game Pass PC на 3 месяца - 1990р (любой аккаунт)
        </span>
      </div>

      {/* <div style={{ marginTop: "20px" }}>📌НОВЫЙ АККАУНТ:</div>
      <div className="subscriptions">
        {subscriptions.map((item) => (
          <div className="subscriptions__item">
            <span className="subscriptions__item-name">{item.name}</span>
            <span> - </span>
            <span className="subscriptions__item-price">{item.price}</span>
          </div>
        ))}
      </div> */}

      <div className="subscriptions_subtext">
        <p>❗ На момент покупки предыдущая подписка должна закончиться.</p>
        <p>
          <p>🆕 Если хотите оформить на новый аккаунт:</p>
          <p>- Аккаунт создаю бесплатно, специально для вас в одни руки 🤝;</p>
          ❓ Остались вопросы пишите в ЛС группы{" "}
          <a
            className="gpoup-information__title"
            href="https://vk.com/life4play1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Life4Play
          </a>
        </p>
      </div>
      <div className="gpoup-information">
        <a
          className="gpoup-information__title"
          href="https://vk.com/life4play1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="gpoup-information__logo" src={logo} />
        </a>

        <a
          className="gpoup-information__title"
          href="https://vk.com/life4play1"
          target="_blank"
          rel="noopener noreferrer"
        >
          Life4Play
        </a>
      </div>
    </>
  );
};

export default SubscriptionsHome;
